var _excluded = ["prefixCls", "children", "action", "showAction", "hideAction", "alignPoint", "popupVisible", "onPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "destroyPopupOnHide", "getPopupContainer", "popup", "popupClassName", "popupStyle", "placement", "arrow", "mask", "maskClosable"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useLayoutEffect, useState } from 'react';
import { cx } from '@emotion/css';
import Popup from "./Popup";
import { triggerPrefix } from "./style";
import { useAction, useAlign } from "./hooks";
import { collectScroller } from "./utils";
import useEvent from "../../hooks/useEvent";

var Trigger = function Trigger(props) {
  var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? triggerPrefix() : _props$prefixCls,
      children = props.children,
      _props$action = props.action,
      action = _props$action === void 0 ? 'hover' : _props$action,
      showAction = props.showAction,
      hideAction = props.hideAction,
      alignPoint = props.alignPoint,
      popupVisible = props.popupVisible,
      onPopupVisibleChange = props.onPopupVisibleChange,
      mouseEnterDelay = props.mouseEnterDelay,
      _props$mouseLeaveDela = props.mouseLeaveDelay,
      mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 100 : _props$mouseLeaveDela,
      destroyPopupOnHide = props.destroyPopupOnHide,
      getPopupContainer = props.getPopupContainer,
      popup = props.popup,
      popupClassName = props.popupClassName,
      popupStyle = props.popupStyle,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'br' : _props$placement,
      arrow = props.arrow,
      mask = props.mask,
      _props$maskClosable = props.maskClosable,
      maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable,
      restProps = _objectWithoutProperties(props, _excluded); // =========================== Popup ============================


  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      popupEle = _useState2[0],
      setPopupEle = _useState2[1];

  var setPopupRef = useEvent(function (node) {
    if (node && popupEle !== node) {
      setPopupEle(node);
    }
  }); // =========================== Target ===========================
  // Use state to control here since `useRef` update not trigger render

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      targetEle = _React$useState2[0],
      setTargetEle = _React$useState2[1];

  var setTargetRef = useEvent(function (node) {
    if (node && targetEle !== node) {
      setTargetEle(node);
    }
  });

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      internalOpen = _React$useState4[0],
      setInternalOpen = _React$useState4[1];

  var mergedOpen = popupVisible !== null && popupVisible !== void 0 ? popupVisible : internalOpen; // 防止popupVisible变为undefined，每次都判断一下

  var setMergedOpen = useEvent(function (nextOpen) {
    if (popupVisible === undefined) {
      setInternalOpen(nextOpen);
    }
  });
  var openRef = React.useRef(mergedOpen);
  openRef.current = mergedOpen;
  var internalTriggerOpen = useEvent(function (nextOpen) {
    if (mergedOpen !== nextOpen) {
      setMergedOpen(nextOpen);
      onPopupVisibleChange === null || onPopupVisibleChange === void 0 ? void 0 : onPopupVisibleChange(nextOpen);
    }
  }); // 延迟的timeout

  var delayRef = React.useRef();

  var clearDelay = function clearDelay() {
    clearTimeout(delayRef.current);
  };

  var triggerOpen = function triggerOpen(nextOpen) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    clearDelay();

    if (delay === 0) {
      internalTriggerOpen(nextOpen);
    } else {
      delayRef.current = setTimeout(function () {
        internalTriggerOpen(nextOpen);
      }, delay);
    }
  };

  useEffect(function () {
    return clearDelay;
  }, []); // children

  var child = typeof children === 'string' ? /*#__PURE__*/React.createElement("span", null, children) : React.Children.only(children);
  var originChildProps = (child === null || child === void 0 ? void 0 : child.props) || {};
  var cloneProps = {};
  var inPopupOrChild = useEvent(function (ele) {
    return (targetEle === null || targetEle === void 0 ? void 0 : targetEle.contains(ele)) || ele === targetEle || (popupEle === null || popupEle === void 0 ? void 0 : popupEle.contains(ele)) || ele === popupEle;
  });

  var _React$useState5 = React.useState([0, 0]),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      mousePos = _React$useState6[0],
      setMousePos = _React$useState6[1];

  var setMousePosByEvent = function setMousePosByEvent(event) {
    setMousePos([event.clientX, event.clientY]);
  };

  var _useAlign = useAlign(mergedOpen, popupEle, alignPoint ? mousePos : targetEle, placement !== null && placement !== void 0 ? placement : 'bl'),
      _useAlign2 = _slicedToArray(_useAlign, 6),
      ready = _useAlign2[0],
      offsetX = _useAlign2[1],
      offsetY = _useAlign2[2],
      arrowX = _useAlign2[3],
      arrowY = _useAlign2[4],
      onAlign = _useAlign2[5];

  useLayoutEffect(function () {
    if (!mergedOpen || !targetEle || !popupEle) return;
    var targetElement = targetEle;
    var popupElement = popupEle;
    var targetScrollList = collectScroller(targetElement);
    var popupScrollList = collectScroller(popupElement);
    var mergedList = new Set([window].concat(_toConsumableArray(targetScrollList), _toConsumableArray(popupScrollList)));

    function notifyScroll() {
      onAlign();
    }

    mergedList.forEach(function (scroller) {
      scroller.addEventListener('scroll', notifyScroll, {
        passive: true
      });
    });
    window.addEventListener('resize', notifyScroll, {
      passive: true
    }); // First time always do align

    onAlign();
    return function () {
      mergedList.forEach(function (scroller) {
        scroller.removeEventListener('scroll', notifyScroll);
        window.removeEventListener('resize', notifyScroll);
      });
    };
  }, [mergedOpen, targetEle, popupEle, onAlign]); // motion

  var placementClass = "".concat(prefixCls, "-").concat(placement);

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      motionClass = _useState4[0],
      setMotionClass = _useState4[1];

  useLayoutEffect(function () {
    if (mergedOpen) {
      setMotionClass("".concat(prefixCls, "-prepare"));
    }
  }, [mergedOpen, prefixCls]);
  useLayoutEffect(function () {
    if (!popupEle) return;

    if (ready) {
      // setMotionClass('');
      var onMotionEnd = function onMotionEnd() {
        setMotionClass('');
        popupEle.removeEventListener('animationend', onMotionEnd);
      };

      popupEle.addEventListener('animationend', onMotionEnd);
      setMotionClass("".concat(prefixCls, "-").concat(placement, "-enter"));
    } else {
      // setMotionClass(`${prefixCls}-popup-hidden`);
      var _onMotionEnd = function _onMotionEnd() {
        setMotionClass("".concat(prefixCls, "-popup-hidden"));
        popupEle.removeEventListener('animationend', _onMotionEnd);
      };

      setMotionClass("".concat(prefixCls, "-").concat(placement, "-leave"));
      popupEle.addEventListener('animationend', _onMotionEnd);
    }
  }, [ready, placement, popupEle, prefixCls]); // ========================= Action =========================

  var _useAction = useAction(action, showAction, hideAction),
      _useAction2 = _slicedToArray(_useAction, 2),
      showActions = _useAction2[0],
      hideActions = _useAction2[1]; // Util wrapper for trigger action, and do something before trigger


  var wrapperAction = function wrapperAction(eventName, nextOpen, delay, preEvent) {
    cloneProps[eventName] = function (event) {
      var _originChildProps$eve;

      preEvent === null || preEvent === void 0 ? void 0 : preEvent(event);
      triggerOpen(nextOpen, delay); // Pass to origin

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      (_originChildProps$eve = originChildProps[eventName]) === null || _originChildProps$eve === void 0 ? void 0 : _originChildProps$eve.call.apply(_originChildProps$eve, [originChildProps, event].concat(args));
    };
  }; // click


  var clickToShow = showActions.includes('click');
  var clickToHide = hideActions.includes('click') || hideActions.includes('contextMenu');

  if (clickToShow || clickToHide) {
    cloneProps.onClick = function (event) {
      var _originChildProps$onC;

      if (openRef.current && clickToHide) {
        triggerOpen(false);
      } else if (!openRef.current && clickToShow) {
        setMousePosByEvent(event);
        triggerOpen(true);
      } // 调用原child的click方法


      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      (_originChildProps$onC = originChildProps.onClick) === null || _originChildProps$onC === void 0 ? void 0 : _originChildProps$onC.call.apply(_originChildProps$onC, [originChildProps, event].concat(args));
    };
  }

  useEffect(function () {
    if (clickToHide && popupEle && (!mask || maskClosable)) {
      var onWindowClick = function onWindowClick(_ref) {
        var target = _ref.target;

        if (openRef.current && !inPopupOrChild(target)) {
          triggerOpen(false);
        }
      };

      window.addEventListener('click', onWindowClick);
      return function () {
        window.removeEventListener('click', onWindowClick);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [clickToHide, popupEle, inPopupOrChild, mask, maskClosable]); // hover

  var hoverToShow = showActions.includes('hover');
  var hoverToHide = hideActions.includes('hover');

  var onPopupMouseEnter = function onPopupMouseEnter() {};

  var onPopupMouseLeave = function onPopupMouseLeave() {};

  if (hoverToShow) {
    // set mouse position for alignment
    wrapperAction('onMouseEnter', true, mouseEnterDelay, function (event) {
      setMousePosByEvent(event);
    });

    onPopupMouseEnter = function onPopupMouseEnter() {
      triggerOpen(true, mouseEnterDelay);
    }; // Align Point


    if (alignPoint) {
      cloneProps.onMouseMove = function (event) {
        var _originChildProps$onM;

        (_originChildProps$onM = originChildProps.onMouseMove) === null || _originChildProps$onM === void 0 ? void 0 : _originChildProps$onM.call(originChildProps, event);
      };
    }
  }

  if (hoverToHide) {
    wrapperAction('onMouseLeave', false, mouseLeaveDelay);

    onPopupMouseLeave = function onPopupMouseLeave() {
      triggerOpen(false, mouseLeaveDelay);
    };
  } // focus


  if (showActions.includes('focus')) {
    wrapperAction('onFocus', true, 0);
  }

  if (hideActions.includes('focus')) {
    wrapperAction('onBlur', false, 0);
  } // contextMenu


  if (showActions.includes('contextMenu')) {
    cloneProps.onContextMenu = function (event) {
      var _originChildProps$onC2;

      setMousePosByEvent(event);
      triggerOpen(true);
      event.preventDefault(); // Pass to origin

      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      (_originChildProps$onC2 = originChildProps.onContextMenu) === null || _originChildProps$onC2 === void 0 ? void 0 : _originChildProps$onC2.call.apply(_originChildProps$onC2, [originChildProps, event].concat(args));
    };
  } // clone child


  var mergedChildrenProps = _objectSpread(_objectSpread({}, originChildProps), cloneProps);

  var passedProps = {};
  var passedEventList = ['onContextMenu', 'onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur'];
  passedEventList.forEach(function (eventName) {
    if (restProps[eventName]) {
      passedProps[eventName] = function () {
        var _mergedChildrenProps$, _ref2;

        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        (_mergedChildrenProps$ = mergedChildrenProps[eventName]) === null || _mergedChildrenProps$ === void 0 ? void 0 : _mergedChildrenProps$.call.apply(_mergedChildrenProps$, [mergedChildrenProps].concat(args));

        (_ref2 = restProps)[eventName].apply(_ref2, args);
      };
    }
  });
  var triggerNode = /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({
    ref: setTargetRef
  }, mergedChildrenProps), passedProps));
  var innerArrow = arrow ? _objectSpread(_objectSpread({}, arrow !== true ? arrow : {}), {}, {
    x: arrowX,
    y: arrowY
  }) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, triggerNode, /*#__PURE__*/React.createElement(Popup, _extends({}, restProps, {
    ref: setPopupRef,
    prefixCls: prefixCls,
    popup: popup,
    className: cx(popupClassName, motionClass, placementClass),
    style: popupStyle,
    target: targetEle,
    onMouseEnter: onPopupMouseEnter,
    onMouseLeave: onPopupMouseLeave // Open
    ,
    open: mergedOpen // Mask
    ,
    mask: mask,
    maskClosable: maskClosable // Motion
    // motion={mergePopupMotion}
    // maskMotion={mergeMaskMotion}
    // onVisibleChanged={onVisibleChanged}
    // onPrepare={onPrepare}
    // Portal
    // forceRender={forceRender}
    ,
    autoDestroy: destroyPopupOnHide,
    getPopupContainer: getPopupContainer // Arrow
    // align={alignInfo}
    ,
    arrow: innerArrow // Align
    ,
    ready: ready,
    offsetX: offsetX,
    offsetY: offsetY // onAlign={triggerAlign}
    // Stretch
    // stretch={stretch}
    // targetWidth={targetWidth / scaleX}
    // targetHeight={targetHeight / scaleY}

  })));
};

export default /*#__PURE__*/React.memo(Trigger);